[<template>
  <div class="pre-checkout">
    <product-gallery :first-name="firstName"
                     :monthly-deposit-sum="monthlyDepositSum" />
    <div class="dry-details r-text-headline-paragraph">
      <div class="info">
        <div class="r-text-intro">ההפקדות שלך</div>
        <div>
          <span>חודשית </span>
          <span class="r-text-bold">{{ formatAmount(monthlyDepositSum) }} ₪</span>
        </div>
        <div class="info" v-if="showOneTimeDeposit">
          <span>חד פעמית </span>
          <span class="r-text-bold">{{ formatAmount(oneTimeDepositSum) }} ₪</span>
        </div>
      </div>
      <div class="info">
        <div class="r-text-intro">דמי ניהול</div>
        <div>{{ COMMISSION_IN_PERCENTAGE }}% מצבירה בלבד</div>
      </div>
      <div class="info">
        <div>
          <div class="r-text-intro">מסלול השקעה</div>
          <div>כללי ב׳מיטב׳</div>
        </div>
      </div>

    </div>

    <default-button label="לרכישה" @click="next" :disable="locked" :loading="locked" />
    <article-button label="שאלות ותשובות נפוצות" @click="openQuestionsAndAnswers" />
    <div style="margin-top: 12px">התנאים המלאים מופיעים <link-button
      class="tc-link-button"
      text="באתר מיטב"
      @click="fullTerms"/></div>
  </div>
</template>

<script>
import _ from 'lodash';
import Segment from '@/Segment';
import { mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import DefaultButton from '@/components/styled/DefaultButton';
import { COMMISSION_IN_PERCENTAGE } from '@/constants/meitav-dash/open-fund';
import Uplift from '@/views/meitav-dash/open-fund/dialogs/Uplift';
import MoneyFormat from '@/mixins/MoneyFormat';
import ProductGallery from '@/components/meitav-dash/open-fund/kgl-carousel/ProductGallery';
import ArticleButton from '@/components/styled/ArticleButton';
import LinkButton from '@/components/base/LinkButton';

export default {
  name: 'PreCheckout',
  components: { LinkButton, ArticleButton, ProductGallery, DefaultButton },
  mixins: [WizardPage, MoneyFormat],
  computed: {
    ...mapState('meitavDash/openFund', ['monthlyDepositSum', 'firstName', 'oneTimeDepositSum', 'showUpliftDialog']),
    COMMISSION_IN_PERCENTAGE() {
      return COMMISSION_IN_PERCENTAGE;
    },
    showOneTimeDeposit() {
      return !_.isNil(this.oneTimeDepositSum) && this.oneTimeDepositSum > 0;
    },
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setUpliftDialogShown']),
    next() {
      if (this.showUpliftDialog) {
        this.$q.dialog({
          component: Uplift,
          parent: this,
          firstName: this.firstName,
        }).onDismiss(() => {
          this.setUpliftDialogShown();
          this.nextPage();
        });
      } else {
        this.nextPage();
      }
    },
    openQuestionsAndAnswers() {
      Segment.trackUserInteraction('Saving_QAClicked');
      window.open('/pdfs/riseup_Q&A.pdf', '_blank');
    },
    fullTerms() {
      Segment.trackUserInteraction('Saving_FullTerms_Meitav');
      window.open('https://www.meitav.co.il/provident_pension/provident_invest/', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.product-gallery {
  margin-bottom: 36px;
}

.dry-details {
  margin-top: 16px;
  .info {
    margin-bottom: 16px;
  }
}

</style>
